// Libraries
import { Card, Flex, Text } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
// Utils
import text from '@translations/en.json';

/**
 * `EmissionsLayout` is a component that provides a layout for the emissions results.
 *
 * @component
 * @param {PropsWithChildren} props - The properties that define the `EmissionsLayout` component.
 * @param {ReactNode} props.children - The child components to be rendered within the layout.
 *
 * @returns {ReactElement} Returns a card containing a title and a flex container for child components.
 */
export const EmissionsLayout = ({ children }: PropsWithChildren) => {
  return (
    <Card w='full' gap={4} px={{ base: 3, md: 6 }} py={{ base: 3, md: 5 }} h='fit-content'>
      <Text fontSize={{ base: 'md', md: 'xl' }} fontWeight='medium' justifySelf='start'>
        {text.cii_simulator.simulation_results_card.title}
      </Text>
      <Flex display='flex' direction='column' align='center' justify='space-between' gap={4}>
        {children}
      </Flex>
    </Card>
  );
};
